import { NodeContext } from "../../../../poly/NodeContext";
import { RopType } from "../../../../poly/registers/nodes/types/Rop";
import { ParamConfig } from "../../../utils/params/ParamsConfig";
import { ObjType } from "../../../../poly/registers/nodes/types/Obj";
export function CameraRenderParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.render = ParamConfig.FOLDER();
      this.setScene = ParamConfig.BOOLEAN(0);
      this.scene = ParamConfig.NODE_PATH("", {
        visibleIf: { setScene: 1 },
        nodeSelection: {
          context: NodeContext.OBJ,
          types: [ObjType.SCENE]
        }
      });
      this.setRenderer = ParamConfig.BOOLEAN(0);
      this.renderer = ParamConfig.NODE_PATH("", {
        visibleIf: { setRenderer: 1 },
        nodeSelection: {
          context: NodeContext.ROP,
          types: [RopType.WEBGL]
        },
        dependentOnFoundNode: true
      });
      this.setCSSRenderer = ParamConfig.BOOLEAN(0);
      this.CSSRenderer = ParamConfig.NODE_PATH("", {
        visibleIf: { setCSSRenderer: 1 },
        nodeSelection: {
          context: NodeContext.ROP,
          types: [RopType.CSS2D, RopType.CSS3D]
        },
        dependentOnFoundNode: true
      });
    }
  };
}
